import { useAppStore } from "@/store/appStore";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Image from "@/components/image";
import Text from "@/components/text/text";

const PoliceOperationsLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="fullscreen_div">
      {children}
    </div>
  );
};
export default PoliceOperationsLayout;
